import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '4vh',
    [theme.breakpoints.down('sm')]: {
      marginTop: '3vh',
    },
  },
  btnWrapper: {
    marginTop: '6vh',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2vh',
    },
  },
  noPadTextarea: {
    '& .MuiInputBase-input': {
      paddingTop: '3px !important',
    },
  },
  formTitleWrapper: {
    background: theme.palette.other.grey,
    paddingLeft: theme.spacing(4.5),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    marginBottom: '0px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(9),
      paddingTop: theme.spacing(8),
    },
  },
  formTitle: {
    fontWeight: '500',
    color: theme.palette.other.dark,
    margin: '0px',
    textAlign: 'left',
  },
  btnSubmit: {
    [theme.breakpoints.down('1366.05')]: {
      fontSize: '1vw !important'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 'clamp(1em, 1vw, 2em) !important',
    }
  }
}))
